import { Badge, Box, Tooltip } from '@mui/material';
import IconButton from 'components/@extended/IconButton';
import { HEADER_ICON_BUTTON_SX, HEADER_ICON_SLOT_SX } from 'components/ui/tokens';
import { PANEL_SOURCES } from '../constants';
import { WHATS_NEW_COPY } from '../content';
import { useWhatsNew } from '../hooks/useAnnouncements';
import { WHATS_NEW_ICON as WhatsNewIcon } from '../postIcon';

const c = WHATS_NEW_COPY.button;

/** The header's What's new button, styled like the notification bell next to it; the badge counts unread posts. */
const WhatsNewButton = () => {
  const { unread, open } = useWhatsNew();
  return (
    <Box sx={HEADER_ICON_SLOT_SX}>
      <Tooltip title={c.label}>
        <IconButton
          color="secondary"
          sx={HEADER_ICON_BUTTON_SX}
          aria-label={c.ariaLabel(unread)}
          aria-haspopup="dialog"
          onClick={() => open(PANEL_SOURCES.header)}
        >
          <Badge badgeContent={unread || null} color="primary">
            <Box sx={{ display: 'flex', fontSize: 18 }}>
              <WhatsNewIcon aria-hidden />
            </Box>
          </Badge>
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default WhatsNewButton;
